<div class="card" *ngIf="hasFilter || AddEnabled">
  <div class="card-body">
    <div *ngIf="hasFilter" class="d-md-flex align-items-center border-top">
      <div class="col-lg-3 form-group">
        <label class="control-label col-form-label text-dark">Cantiere</label>
        <input type="text" #nominativo="ngModel" [(ngModel)]="Filter.cliente" (ngModelChange)="refreshTable(1)" name="cliente"
          class="form-control">
      </div>
      <div class="col-lg-2">
        <div class="form-group">
          <label for="inizio" class="control-label col-form-label">Inizio</label>
          <input id="inizio" required [(ngModel)]="Filter.inizio" (ngModelChange)="refreshTable(1)" class="form-control" type="date">
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group">
          <label for="fine" class="control-label col-form-label">Fine</label>
          <input id="fine" required [(ngModel)]="Filter.fine" (ngModelChange)="refreshTable(1)" class="form-control" type="date">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button *ngIf="AddEnabled "  type="button" class=" btn btn-cyan rounded-pill p-2" (click)='Add()'>
        <i class="fas fa-plus  font-14 mr-1 text-white"> </i>
        <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
      </button>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <tbody>
          <tr *ngFor="let item of List | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
            <td class="align-middle" (click)='edit(item)'>
              <span>

                <span *ngIf="item.nome">{{ item.nome }}</span> <br>
                <span *ngIf="item.nome">{{ item.data_inizio_prevista  | date : 'dd/MM/yyyy HH:mm'}}</span><br>
                <span *ngIf="item.nome">{{ item.data_fine_prevista | date : 'dd/MM/yyyy HH:mm' }}</span><br>
              </span>
            </td>
            <td class="align-middle">
              <a href="javascript:void(0)" ngbTooltip="Modifica" class="link text-info font-16 font-medium mr-2" (click)='edit(item)'>
                <i-feather name="edit-3" class="feather-sm"></i-feather>
              </a>
              <a href="javascript:void(0)" ngbTooltip="Elimina" class="link font-16 text-danger font-weight-bold"
              (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
              <!-- <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='viewClicked(co)'>
                <i-feather name="eye" class="feather-sm"></i-feather>
              </a> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="hasPagination"  class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
      <ngb-pagination (pageChange)="getPage($event)" [maxSize]="10" [collectionSize]="collectionSize" [pageSize]="pageSize">
      </ngb-pagination>
    </div>
  </div>
</div>
